import React, {
  createContext,
  useContext,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
} from "react";
import type { AdminDashboardLocale } from "./admin-dashboard-locale";

export type AdminDashboardLocaleContextValue = {
  locale: AdminDashboardLocale;
  setLocale: Dispatch<SetStateAction<AdminDashboardLocale>>;
};

const AdminDashboardLocaleContext = createContext<AdminDashboardLocaleContextValue | null>(null);

export function AdminDashboardLocaleProvider(props: {
  children: ReactNode;
  value: AdminDashboardLocaleContextValue;
}) {
  return (
    <AdminDashboardLocaleContext.Provider value={props.value}>
      {props.children}
    </AdminDashboardLocaleContext.Provider>
  );
}

export function useAdminDashboardLocale(): AdminDashboardLocaleContextValue {
  const value = useContext(AdminDashboardLocaleContext);
  if (!value) {
    throw new Error("Admin dashboard locale context is not available.");
  }

  return value;
}
